<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  <rx-alert class="mt-3" type="warning">
    <div class="f-family-bold">
      <span>{{ t(createHeaderMessage(isOutOfPolicyRequest, approvers)) }}</span>
      <span class="single-approver-email" *ngIf="approvers.length === 1">{{ approvers[0].username }} </span>
      <span *ngIf="approvers.length > 1">
        <rx-icon [name]="'info'" [ngbTooltip]="approversTooltip" tooltipClass="approversTooltip border"></rx-icon>
      </span>
    </div>
    <div>{{ t('bookingApprovalWarningBody') }}</div>
    <ng-template #approversTooltip>
      <div class="container p-3">
        <div *ngFor="let approver of approvers" class="text-left">
          {{ approver.username }}
        </div>
      </div>
    </ng-template>
  </rx-alert>
</ng-container>
